import { useState } from 'react';

import QuotationHeaderBar from '../header/QuotationHeaderBar';

import QuotationNotesSection from '../header/QuotationNotesSection';

import QuotationPaymentConditionSection from '../header/QuotationPaymentConditionSection';

import QuotationProductPanel from '../product-panel/QuotationProductPanel';

import QuotationSummaryPanel from '../product-panel/summary/QuotationSummaryPanel';

import { useQuotation } from '../../../../../hooks/sale/useQuotation';

import { useQuotationItem } from '../../../../../hooks/sale/useQuotationItem';

import { ProductPanelItem } from '../../../../../types/productpanel/ProductPanelItem';

import QuotationAddProductModal from '../../modal/QuotationAddProductModal';

import QuotationUpdateSelectedProductModal from '../../modal/QuotationUpdateSelectedProductModal';

import POSTabSection from '../../../pos/POSTabSection';

import PendingQuotationsPanel from '../../../pos/tabs/PendingQuotations/PendingQuotationsPanel';
import QuotationHistoryPanel from '../../../pos/tabs/QuotationHistory/QuotationHistoryPanel';
import ProcessQuotationModal from '../../modal/ProcessQuotationModal';
import QuotationViewModal from '../../modal/view/QuotationViewModal';
import QuotationPriceCheckPanel from '../../../pos/tabs/PriceCheck/QuotationPriceCheckPanel';

const QuotationRegistrationPanel = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const {
    form,

    selectedQuotation,
    showQuotationModal,
    closeQuotationModal,

    selectedProduct,

    handlerSelectProduct,

    processQuotation,

    showProcessModal,

    closeProcessModal,
  } = useQuotation();

  const {
    addItem,

    updateItem,
  } = useQuotationItem();

  // =====================================================
  // 🔹 State
  // =====================================================

  const [selectedProductToAdd, setSelectedProductToAdd] =
    useState<ProductPanelItem | null>(null);

  // =====================================================
  // 🔹 Handlers
  // =====================================================

  const handleOpenProductModal = (product: ProductPanelItem) => {
    setSelectedProductToAdd(product);
  };

  const handleCloseProductModal = () => {
    setSelectedProductToAdd(null);
  };

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <>
      <div className="flex flex-col gap-4">
        {/* ===================================================== */}
        {/* 🔹 Header */}
        {/* ===================================================== */}

        <QuotationHeaderBar />

        {/* ===================================================== */}
        {/* 🔹 Main Content */}
        {/* ===================================================== */}

        <div
          className="
            mb-5
            grid

            gap-4

            xl:grid-cols-[1fr_380px]
          "
        >
          {/* ===================================================== */}
          {/* 🔹 Workspace */}
          {/* ===================================================== */}

          <POSTabSection
            defaultTab="products"
            tabs={[
              {
                key: 'products',

                label: 'Productos',

                content: (
                  <div className="space-y-4">
                    <QuotationProductPanel
                      onAddProductClick={handleOpenProductModal}
                    />

                    <QuotationPaymentConditionSection />

                    <QuotationNotesSection />
                  </div>
                ),
              },

              {
                key: 'pending-quotations',

                label: 'Cotizaciones pendientes',

                content: <PendingQuotationsPanel />,
              },

              {
                key: 'quotation-history',

                label: 'Historial',

                content: <QuotationHistoryPanel />,
              },

              {
                key: 'price-check',
                label: 'Consulta de Precios',
                content: <QuotationPriceCheckPanel />,
              },
            ]}
          />

          {/* ===================================================== */}
          {/* 🔹 Summary */}
          {/* ===================================================== */}

          <section
            className="
              sticky
              top-4

              h-fit
            "
          >
            <QuotationSummaryPanel />
          </section>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Add Product */}
      {/* ===================================================== */}

      {selectedProductToAdd && (
        <QuotationAddProductModal
          isOpen={true}
          product={selectedProductToAdd}
          quotationId={form?.id || 0}
          onClose={handleCloseProductModal}
          onConfirm={async (payload) => {
            await addItem(form.id, payload);
            handleCloseProductModal();
          }}
        />
      )}

      {/* ===================================================== */}
      {/* 🔹 Update Product */}
      {/* ===================================================== */}

      {selectedProduct && (
        <QuotationUpdateSelectedProductModal
          isOpen={true}
          onClose={() => handlerSelectProduct(null)}
          onSave={async (updated) => {
            await updateItem(form.id, selectedProduct.id, updated);
            handlerSelectProduct(null);
          }}
        />
      )}

      {/* ===================================================== */}
      {/* 🔹 Process Quotation */}
      {/* ===================================================== */}

      {showProcessModal && (
        <ProcessQuotationModal
          isOpen={true}
          quotationId={selectedQuotation?.id || 0}
          loading={false}
          onClose={closeProcessModal}
          onProcess={async (quotationId, documentTypeId) => {
            await processQuotation(quotationId, documentTypeId);
            closeProcessModal();
          }}
        />
      )}

      <QuotationViewModal
        isOpen={showQuotationModal}
        onClose={closeQuotationModal}
        quotation={selectedQuotation}
      />
    </>
  );
};

export default QuotationRegistrationPanel;
